import axios from "axios";

export const getDeviceOnlineStatusAPI = async (nubisVersion, params) => {
  let response = await axios({
    url: `/api/v2/statistic/devices-heartbeat-status`,
    method: "GET",
    params: {
      nubis_version: nubisVersion,
      ...params
    }
  });
  if (response.data && response.data.stat) {
    return response.data.stat;
  }
};
